import CardPage from './CardPage.vue';

export { CardPage };
export default CardPage;
